import { LoginForm } from "@/components/auth/LoginForm";

/** Unified login page — delegates to the shared LoginForm. */
export function LoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <LoginForm />
    </div>
  );
}

